/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Pipe, PipeTransform} from '@angular/core';
import {CurrencyValue} from "./currency-value.model";

@Pipe({
  name: 'currencyValue'
})
export class CurrencyValuePipe implements PipeTransform {

  transform(currencyValue: CurrencyValue): string {
    return currencyValue ? currencyValue.value?.toFixed(2) + ' ' + currencyValue.currencyCode?.valueOf() : undefined
  }

}
